export default __webpack_public_path__ + "static/media/accountCircle.57b9637d.svg";